module.exports = __webpack_public_path__ + "img/1559514079.4bdd4e06.jpg";